import { Component, OnInit } from '@angular/core';
import {AdvFormService} from "../services/adv-form.service";

@Component({
    selector: 'app-image-list',
    templateUrl: './image-list.component.html',
    styleUrls: ['./image-list.component.css'],
    standalone: false
})
export class ImageListComponent implements OnInit {
  imageList = new Map();
  constructor(private formService: AdvFormService) { }

  // Photo shown in each slot (0 = main photo).
  slots: (string | null)[] = [null, null, null, null, null];

  /** Back on this step: show the photos already picked ([position, dataURL] pairs). */
  ngOnInit(): void {
    const saved = this.formService.getQuestion('images');
    if (!Array.isArray(saved)) return;
    for (const pair of saved) {
      if (!Array.isArray(pair) || pair.length < 2) continue;
      const position = Number(pair[0]);
      if (position >= 0 && position < this.slots.length && pair[1]) {
        this.imageList.set(position, pair[1]);
        this.slots[position] = pair[1];
      }
    }
  }

  onChange(imageFile: string, position: number) {
    this.imageList.set(position, imageFile);
    this.slots[position] = imageFile;
    this.formService.addQuestion('images', Array.from(this.imageList));
  }
}
